import type {
  AttributeExpressionOption,
  ProductCustomAttribute
} from 'shared-types';
import type { ReduxRootState } from 'types';

interface Params {
  messages: ReduxRootState['messages'];
  type: ProductCustomAttribute['type'] | 'Text' | 'all';
}

type FunctionReturn = {
  label: string;
  value: AttributeExpressionOption;
};

const attributesExpressionOptions = ({
  messages,
  type
}: Params): FunctionReturn[] => {
  const expressionEqual = {
    label: messages.userAttributesEquals,
    value: 'equals' as FunctionReturn['value']
  };
  const expressionGreaterThan = {
    label: messages.userAttributesGreaterThan,
    value: 'greater' as FunctionReturn['value']
  };
  const expressionIncludes = {
    label: messages.userAttributesIncludes,
    value: 'includes' as FunctionReturn['value']
  };
  const expressionIncludesOneOf = {
    label: messages.userAttributesIncludesOneOf,
    value: 'includes one of' as FunctionReturn['value']
  };
  const expressionIsEmpty = {
    label: messages.userAttributesIsEmpty,
    value: 'empty' as FunctionReturn['value']
  };
  const expressionIsOneOf = {
    label: messages.userAttributesIsOneOf,
    value: 'is one of' as FunctionReturn['value']
  };
  const expressionIsSet = {
    label: messages.userAttributesHasAny,
    value: 'any' as FunctionReturn['value']
  };
  const expressionLessThan = {
    label: messages.userAttributesLessThan,
    value: 'lesser' as FunctionReturn['value']
  };
  const expressionNotEqual = {
    label: messages.userAttributesNotEquals,
    value: 'not equals' as FunctionReturn['value']
  };
  const expressionNotIncludes = {
    label: messages.userAttributesNotIncludes,
    value: 'not includes' as FunctionReturn['value']
  };

  const expressionByType = {
    all: [
      expressionEqual,
      expressionIsOneOf,
      expressionIncludes,
      expressionIncludesOneOf,
      expressionGreaterThan,
      expressionLessThan,
      expressionNotEqual,
      expressionNotIncludes
    ],
    common: [expressionIsSet, expressionIsEmpty],
    Array: [expressionIncludes, expressionNotIncludes, expressionIncludesOneOf],
    ArrayWithOptions: [
      expressionIncludes,
      expressionNotIncludes,
      expressionIncludesOneOf
    ],
    Boolean: [expressionEqual, expressionNotEqual],
    Number: [
      expressionEqual,
      expressionNotEqual,
      expressionGreaterThan,
      expressionLessThan
    ],
    String: [
      expressionEqual,
      expressionNotEqual,
      expressionIsOneOf,
      expressionIncludes,
      expressionNotIncludes
    ],
    StringWithOptions: [
      expressionEqual,
      expressionNotEqual,
      expressionIsOneOf,
      expressionIncludes,
      expressionNotIncludes
    ],
    Text: [
      expressionEqual,
      expressionNotEqual,
      expressionIncludes,
      expressionNotIncludes
    ]
  };

  return [...expressionByType.common, ...expressionByType[type || 'String']];
};

export default attributesExpressionOptions;
